import React from 'react';

import formatter from '../../utilities/formatter';
import PaymentDisplay from '../payment/PaymentDisplay';

const OpenBalancesItem = ({
    fetchData,
    item
}) => {
    const getOverdueStyle = item.overdue ? { color: "#990033" } : {};

    const iconSrc = item.recordType === 'job' ? '/images/job_dark.svg' : '/images/miscsale_dark.svg';
    const iconHeight = item.recordType === 'job' ? '10px' : '15px';

    return (
        <tr>
            <td style={{ textAlign: 'center', padding: '0' }}><img src={iconSrc} height={iconHeight} /></td>
            <td>{item.customerFirstName + ' ' + item.customerLastName}</td>
            <td className="d-none d-sm-table-cell">{formatter.date(item.date)}</td>
            <td className="d-none d-sm-table-cell">{item.paymentTerms}</td>
            <td style={getOverdueStyle}>{formatter.date(item.dateDue)}</td>
            <td className="text-right">{formatter.currency(item.balance)}</td>
            <td className="text-center">
                <PaymentDisplay
                    customerId={item.customerId}
                    parentId={item.recordId}
                    recordType={item.recordType}
                    resetParentForm={fetchData}
                />
            </td>
        </tr>
    );
}

export default OpenBalancesItem;